export default __webpack_public_path__ + "static/thehub-sm-edd123edfdc4816843e94d7be2039dae.png";